import eci_Stepper from './components/eci/Stepper'
import eci_Support from './components/eci/Support'
import eci_Email from './components/eci/Email'
import Share from './components/Share'
import T from './components/T'
import eci_More from './components/eci/More'

import apConfig from "@config/186.json"
if (apConfig.actionpage && apConfig.template && apConfig.template == true) { apConfig.actionpage = null; }
export const config = apConfig
export const steps = {eci_Stepper,eci_Support,eci_Email,Share}

export const portals = {T,eci_More}

